import { connect } from 'react-redux';
import { getCurrentBackgroundId, getIsBackgroundsPopupOpen } from '../../../DeviationBackground/redux/selectors';
import { initializeBackgrounds, showBackgroundPicker } from '../../../DeviationBackground/redux/actions';
const mapStateToProps = (state, { deviation })=>{
    return {
        currentBackgroundId: getCurrentBackgroundId(state, deviation),
        isBackgroundsPopupOpen: getIsBackgroundsPopupOpen(state)
    };
};
const mapDispatchToProps = {
    onInitialize: initializeBackgrounds,
    showBackgroundPicker
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=EditBackgroundButton.container.js.map